<template>
    <div class="productdetail-container">
        <div class="header-return">
            <el-button type="text" icon="el-icon-arrow-left" @click="returnHistory">返回</el-button>
            <el-button type="primary" size="mini" @click="addGroup(groupDetail)" class="header-btn">保 存</el-button>
        </div>

        <el-form :model="groupDetail" label-width="120px">
            <el-form-item label="套装名称" >
                <el-input v-model="groupDetail.groupName" placeholder="套装名称"></el-input>
            </el-form-item>
            <el-form-item label="套装别名" >
                <el-input v-model="groupDetail.groupOtherName" placeholder="套装别名"></el-input>
            </el-form-item>
            <el-form-item label="套装原价" >
                <el-input v-model="groupDetail.price" placeholder="套装原价"></el-input>
            </el-form-item>
            <el-form-item label="套装销售价" >
                <el-input v-model="groupDetail.salePrice" placeholder="套装销售价"></el-input>
            </el-form-item>
            <el-form-item label="套装计算价格" >
                <el-select v-model="groupDetail.splitPriceMode" clearable filterable  placeholder="套装计算价格方式">
                    <el-option
                            v-for="item in priceState"
                            :key="item.key"
                            :label="item.value"
                            :value="item.key">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="可用优惠券">
                <el-select v-model="groupDetail.useCoupon" clearable filterable  placeholder="可用优惠券">
                    <el-option
                            v-for="item in couponUse"
                            :key="item.key"
                            :label="item.value"
                            :value="item.key">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="单位" >
                <el-input v-model="groupDetail.groupUnit" placeholder="单位"></el-input>
            </el-form-item>
            <el-form-item label="规格" >
                <el-input v-model="groupDetail.spec" placeholder="规格"></el-input>
            </el-form-item>
            <el-form-item label="限购数" >
                <el-input v-model="groupDetail.limitBuyCount" placeholder="限购数"></el-input>
            </el-form-item>
            <el-form-item label="总库存" >
                <el-input v-model="groupDetail.balanceCount" placeholder="总库存"></el-input>
            </el-form-item>
            <el-form-item label="概述" >
                <el-input v-model="groupDetail.summary" placeholder="概述"></el-input>
            </el-form-item>
            <el-form-item label="列表是否显示">
                <el-select v-model="groupDetail.showState" clearable filterable  placeholder="列表是否显示">
                    <el-option
                            v-for="item in showState"
                            :key="item.key"
                            :label="item.value"
                            :value="item.key">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item >
                <el-button type="primary" size="mini" @click="addGroup(groupDetail)" class="header-btn">保 存</el-button>
            </el-form-item>
        </el-form>
    </div>
</template>

<script>
    import {addGroup} from '@/api/api'

    export default{
        data(){
            return {
                priceState:[{
                    key:0,
                    value:'统一商品折扣'
                },
                {
                    key:1,
                    value:'独立配置各商品价格'
                }],
                couponUse:[{
                    key:0,
                    value:'不可用'
                },
                {
                    key:1,
                    value:'可用'
                }],
                showState:[{
                    key:0,
                    value:'列表不显示'
                },
                {
                    key:1,
                     value:'列表显示'
                }],
            }
        },
        computed:{
            groupDetail:function () {
                return this.$store.getters.getGroupDetail
            },
            productTypes:function () {
                return this.$store.getters.getProductType
            }
        },
        mounted(){
            this.$store.dispatch('initGroupDetail',this.$route.params.id);
        },
        methods:{
            addGroup(form){
                addGroup(form).then((res) => {
                    if(res.data.status==200){
                        this.$message({
                            showClose: true,
                            message: '成功',
                            type: 'success'
                        });
                        window.history.go(-1)
                    }else{
                        this.$message({
                            showClose: true,
                            message: res.data.message,
                            type: 'error'
                        });
                    }
                })
            },
            returnHistory(){
                window.history.go(-1)
            }
        }
    }
</script>

<style lang="scss" rel="stylesheet/scss" scoped>
    .productdetail-container{
        padding: 10px 20px;
        .header-return{
            margin-bottom: 20px;
            border-bottom: 1px solid #eeeeee;
            padding-bottom: 10px;
        }
        .header-btn{
            float: right;
        }
    }
</style>


// WEBPACK FOOTER //
// src/views/editDetail/groupdetail.vue